import { LoadExistingApp } from "features/search/LoadExisting";
import { Map } from "immutable";
import React from "react";
import styles from "./SearchDemo.scss";

export class SearchDemo extends React.PureComponent {
  render() {
    // These are just example default search params
    const query = Map({
      user_id: 1,
    });

    return (
      <div className={styles.SearchDemo}>
        <LoadExistingApp initialQuery={query} />
      </div>
    );
  }
}
